export const FILTERS_LOADING = 'FILTERS_LOADING';
export const FILTERS_RECEIVED = 'FILTERS_RECEIVED';
export const FILTERS_ERROR = 'FILTERS_ERROR';



// WEBPACK FOOTER //
// ./src/data/redux/filter_details/actiontypes.js